import React from 'react'

import './index.scss'

export const IndentLeft: React.FC = () => (
  <svg className="icon icon--indent-left" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
    <path className="fill" d="M16.005 9.61502L21.005 13.1864L21.005 6.04361L16.005 9.61502Z" />
    <rect className="fill" height="2.15625" width="9.0675" x="5" y="5.68199" />
    <rect className="fill" height="2.15625" width="9.0675" x="5" y="11.4738" />
    <rect className="fill" height="2.15625" width="16.005" x="5" y="17.2656" />
  </svg>
)
